// noinspection ES6UnusedImports
import React, {Fragment} from 'react';
import CartDeliverabilityHint from './CartDeliverabilityHint.jsx';
import Device from '@core/scripts/components/device';
import {Button, Icon, Typography, useBreakpointUp} from '@bonprix/design-system';

export default function CartTop({
                                    cart,
                                    hideHeaderButton,
                                    texts,
                                    onCartButtonClick,
                                    disableCartToCheckoutButton,
                                    isDeliveryToPickUpLocationNotPossible,
                                    loading
                                }) {
    const hideHeadlineWhenDeviceIsApp = Device.isApp();
    const isLOrUp = useBreakpointUp("l");

    return (
        <>
            <CartDeliverabilityHint
                items={cart.items}
                isDeliveryToPickUpLocationNotPossible={isDeliveryToPickUpLocationNotPossible}
                texts={texts}
            />

            <div className="cart__top flex flex-wrap">
                <div className="cart__top--first order-1 l:pl-2.5">
                    {!hideHeadlineWhenDeviceIsApp && (
                        <div className="s:text-center l:text-left l:mt-2.5">
                            <Typography variant="bonprix-h4" component="h1" align={isLOrUp ? 'left' : 'center'}>
                                {texts.cot09_wk_my_shopping_cart}
                            </Typography>
                        </div>
                    )}

                    <section className="cart__summary--top text-center l:text-left l:mt-5">
                        <Typography component="span" color="on-bg-mid" align={isLOrUp ? 'left' : 'center'}>
                            {texts.bp_bestellwert} ({cart.summary.itemCount} {texts.wishlist_artikel}): {cart.summary.cartPrice}
                        </Typography>
                    </section>
                </div>

                <CartButton
                    hideHeaderButton={hideHeaderButton}
                    texts={texts}
                    onCartButtonClick={onCartButtonClick}
                    disableCartToCheckoutButton={disableCartToCheckoutButton}
                    loading={loading}
                />

                <div className="cart-top__divider-cell order-10 l:px-2.5">
                    <div className="cart-top__divider" />
                </div>
            </div>
        </>
    );
}

function CartButton({hideHeaderButton, texts, onCartButtonClick, disableCartToCheckoutButton, loading}) {
    if (hideHeaderButton) {
        return null;
    }

    return (
        <div className="cart__top--third order-3 l:px-2.5 l:order-2">
            <Button
                id={'test-ref__cart-button-next'}
                className="cart__button-next"
                variant="primary"
                icon="arrow-right"
                iconPosition="end"
                disabled={disableCartToCheckoutButton}
                onClick={onCartButtonClick}
                loading={loading}
            >
                {texts.cot09_wk_proceed_to_checkout}
            </Button>
            <div className="cart__protected-submission">
                <Icon variant='lock' className='text-clr-on-bg-mid'/>
                <span className="cart__protected-submission-message">
                    <Typography component="span" color="on-bg-mid">{texts.bff_secure_data_transfer}</Typography>
                </span>
            </div>
        </div>
    );
}
